/**
 * Component Registry for Bolero
 * 
 * Inherits from @vibesites-weidner-apartment-homes-oasis/theme-oasis and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-weidner-apartment-homes-oasis/theme-oasis/registry';
import { PropertyOverview } from './components/PropertyOverview';
import { FloorplansList } from './components/FloorplansList';
import { HomeNeighborhood } from './components/HomeNeighborhood';
import { ContactBlock } from './components/ContactBlock';
import { SpecialOfferBanner } from './components/SpecialOfferBanner';
import { Header } from './components/Header';

/**
 * Property-specific component overrides.
 * These fork the inherited oasis components solely to render their
 * section titles in the text-on-primary color.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  PropertyOverview,
  FloorplansList,
  HomeNeighborhood,
  ContactBlock,
  SpecialOfferBanner,
  // Nests FAQ under Contact Us in the main nav.
  Header,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
